import React from "react";
import { Autocomplete, Button, CircularProgress, Divider, FormControl, Grid, IconButton, MenuItem, Select, TextField, Tooltip, Typography } from "@mui/material";
import { Info } from "@material-ui/icons";
import DataBlockCounter from "./DataBlockCounter";

const PauseResumeServiceLine = (props) => {
    const {
        pauseData, rejectReason, setRejectReason, endNow, handleChangeEndNow,
        handleClose, handlePauseResume,
        formattedSubscriptionDetails = [], selectedPlan, handleChangeUsageType,
        dataBlocksCurrent = {}, setDataBlocksCurrent, setDataBlockAll,
        isAdmin, handleResumeAssignPlan, isAssigning,
    } = props;

    const isResume = pauseData?.action === "Resume";
    const isStandardWithBlocks = selectedPlan && !selectedPlan?.isCustomPlan && selectedPlan?.data_block_products?.length > 0;
    const hasAnyBlock = Object.values(dataBlocksCurrent || {}).some((v: any) => (v || 0) > 0);

    const resumeDisabled =
        !selectedPlan ||
        (isStandardWithBlocks && !hasAnyBlock);

    return (
        <div className="pause-resume-container">
            {pauseData && pauseData?.action != '' && pauseData?.action === "Pause" &&
                <div className="pause-container-starlink">
                    <Grid item xs={12} sm={12} md={12} lg={12} className="config-configuration-form-deploy select-config-from" >
                        <span id="content-left-text">End On</span>
                        <Grid className="configuration-form-build">
                            <FormControl>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={endNow === true ? "Yes" : "No"}
                                    label=""
                                    onChange={handleChangeEndNow}
                                    size="small"
                                >
                                    <MenuItem value="Yes">Now</MenuItem>
                                    <MenuItem value="No">Billing Date</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} className="config-configuration-form-deploy select-config-from" >
                        <span id="content-left-text">Reason</span>
                        <Grid className="configuration-form-build">
                            <FormControl>
                                <TextField sx={{ padding: 0 }}
                                    className="audit-filter-inputs"
                                    size="small"
                                    variant="outlined"
                                    placeholder="Description(Optional)"
                                    value={rejectReason}
                                    onChange={(e) => { setRejectReason(e.target.value) }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </div>
            }
            {isResume &&
                <div className="pause-container-starlink">
                    <Grid container spacing={2} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Grid item xs={12} container alignItems="center" spacing={1}>
                            <Grid item xs={3}>
                                <Typography variant="subtitle1">Select Products</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Autocomplete
                                    fullWidth
                                    disableClearable
                                    options={formattedSubscriptionDetails}
                                    getOptionDisabled={(option: any) => option?.active === false}
                                    value={selectedPlan || null}
                                    onChange={(e, newValue: any) => {
                                        if (newValue?.name === "Custom Plans" || newValue?.name === "Standard Plans" || newValue?.name?.startsWith?.("Account ")) {
                                            e.preventDefault();
                                            return;
                                        }
                                        handleChangeUsageType(newValue || null);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} size="small" />
                                    )}
                                    getOptionLabel={(option: any) => option?.label || ''}
                                    renderOption={(optionProps, option: any) => (
                                        <React.Fragment key={option.label}>
                                            {option.name === "Custom Plans" || option.name === "Standard Plans" || option.name?.startsWith?.("Account ") ? (
                                                <li
                                                    {...optionProps}
                                                    style={{
                                                        pointerEvents: 'none',
                                                        backgroundColor: '#f5f5f5',
                                                        padding: '8px 16px'
                                                    }}
                                                >
                                                    {option.label}
                                                </li>
                                            ) : (
                                                <li {...optionProps}>{option.label}</li>
                                            )}
                                            {option.hasDivider && <Divider />}
                                        </React.Fragment>
                                    )}
                                />
                            </Grid>
                        </Grid>

                        {isStandardWithBlocks &&
                            <Grid item xs={12}>
                                <span className="local-priority-plan-title">Plan Data Rates</span>
                                <div className="local-priority-plan-card">
                                    <div className="local-priority-plan-header">
                                        <span className="local-priority-plan-title">Recurring Plans
                                            <Tooltip title="Unsused Data will not be carried forward for subsequent billing cycles">
                                                <IconButton size='small' color="primary">
                                                    <Info fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </span>
                                        <span className="local-priority-plan-price">${selectedPlan?.price}<span className="local-priority-plan-duration">/mo</span></span>
                                    </div>
                                    <div className="local-priority-plan-row">
                                        <span className="local-priority-plan-data-label2">Data Block</span>
                                        {isAdmin && <span className="local-priority-plan-data-label2">Price</span>}
                                        <span className="local-priority-plan-data-label2">Current Month</span>
                                    </div>
                                    {selectedPlan?.data_block_products?.map((planRow: any) => {
                                        const key = planRow.product_id;
                                        return (
                                            <div className="local-priority-plan-row" key={key}>
                                                <span className="local-priority-plan-data-label">{planRow.data_amount + " " + planRow?.data_unit}</span>
                                                {isAdmin &&
                                                    <span className="local-priority-plan-cost">
                                                        {`${planRow.iso_currency_code} ${planRow.price}  `}
                                                    </span>}
                                                <DataBlockCounter
                                                    value={(dataBlocksCurrent && dataBlocksCurrent[key]) || 0}
                                                    onChange={(newValue) => {
                                                        setDataBlocksCurrent?.((prev: any) => ({ ...prev, [key]: newValue }));
                                                        setDataBlockAll?.((prev: any) => ({ ...prev, [key]: newValue }));
                                                    }}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            </Grid>
                        }
                    </Grid>
                </div>
            }
            <div className="edit-actions-confirm-btns starlink-admin-edit-actions-confirm-btns">
                <Divider className="confirm-dialogue-new-divider" />
                <div className="confirm-dialogue-new-btns">
                    <Button className="confirm-dialogue-cancel" onClick={handleClose}> Cancel </Button>
                    {isResume ? (
                        <Button
                            className={resumeDisabled ? 'confirm-dialogue-proceed-notAllow' : 'confirm-dialogue-proceed'}
                            onClick={() => handleResumeAssignPlan?.()}
                            disabled={resumeDisabled || isAssigning}
                        >
                            {isAssigning ? <CircularProgress style={{ height: "20px", width: "20px", color: "#ffffff" }} /> : "Resume"}
                        </Button>
                    ) : (
                        <Button className="confirm-dialogue-proceed" onClick={() => { handlePauseResume(); }}>
                            {pauseData?.action}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PauseResumeServiceLine;
